import { useState } from 'react'
import { createFileRoute, useRouter } from '@tanstack/react-router'

import {
  Button,
  Card,
  ContentWrapper,
  Flex,
  FormFields,
  H6,
  Label,
  Paragraph,
  Select,
} from '~/components/elements'
import { Constants } from '~/utils/Constants'

export const Route = createFileRoute('/_authenticated/support/report-fault')({
  component: SupportReportFaultPage,
})

function SupportReportFaultPage() {
  const router = useRouter()
  const [selectedIssue, setSelectedIssue] = useState('')

  return (
    <ContentWrapper>
      <H6>Report a Fault</H6>
      <Card>
        <FormFields>
          <Label>Select Issue</Label>
          <Select
            block="true"
            onChange={(e) => setSelectedIssue(e.target.value)}
            value={selectedIssue}
          >
            <option value="">Please select issue</option>
            <option value="BillingOrGeneralEnquiry">
              Billing / General Enquiry
            </option>
            <option value="TechnicalSupport">Technical Support</option>
          </Select>
        </FormFields>
        {selectedIssue === 'BillingOrGeneralEnquiry' && (
          <div>
            <H6>Billing or General Enquiries?</H6>
            <Paragraph>
              {Constants.WHOLESALERCODE == 'OE' ? (
                <>
                  Skip the call queue and connect with our{' '}
                  <a
                    className="link"
                    href="https://www.originenergy.com.au/chat/internet/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Live Chat Team:
                  </a>
                  <br />
                </>
              ) : (
                <>
                  Call us on {Constants.WHOLESALERSETTINGS.contactSupport}{' '}
                  <br />
                </>
              )}
              <strong>
                {Constants.WHOLESALERSETTINGS.contactSupportHours}
              </strong>
            </Paragraph>
            <Paragraph>
              Our team is here to help you. Send us a message during these
              hours, and one of our specialists will respond as soon as they
              can.
            </Paragraph>
            <Paragraph>
              Contacting us outside these hours? Call us on{' '}
              <strong>
                {Constants.WHOLESALERSETTINGS.contactSupport},{' '}
                {Constants.WHOLESALERSETTINGS.contactSupportHours}
              </strong>
            </Paragraph>
          </div>
        )}
        {selectedIssue === 'TechnicalSupport' && (
          <div>
            <H6>Need Technical Support?</H6>
            <Paragraph>
              We recommend completing some basic troubleshooting steps, starting
              with power cycling your modem.
              {Constants.WHOLESALERCODE === 'OE' && (
                <>
                  <br />
                  You’ll find a step-by-step guide here:{' '}
                  <a
                    className="link"
                    href={
                      'https://www.originenergy.com.au/help-support/internet-products-and-services/modems-and-hardware/power-cycle-your-modem'
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Power Cycle Your Modem | Help & Support.
                  </a>
                </>
              )}
            </Paragraph>
            <Paragraph>
              If this doesn't work call our support team on{' '}
              <strong>
                {Constants.WHOLESALERSETTINGS.contactSupport},{' '}
                {Constants.WHOLESALERSETTINGS.contactSupportHours}.
              </strong>
              <br />
              To ensure the best support, please make sure you're at home when
              you call, so we can solve your issue quickly.
            </Paragraph>
            {Constants.WHOLESALERCODE === 'OE' && (
              <Paragraph>
                We encourage you to download the Origin Internet Helper app:{' '}
                <a
                  className="link"
                  href="https://www.originenergy.com.au/help-support/internet-products-and-services/troubleshooting/download-and-use-origin-internet-helper"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download & Use Origin Internet Helper | Help & Support.
                </a>
                <br />
                This tool helps our specialists quickly diagnose and resolve
                issues with your service.
              </Paragraph>
            )}
          </div>
        )}

        <Flex alignitems="start" justifycontent="space-between">
          <Button
            type="button"
            variant="secondary"
            onClick={() => router.history.back()}
          >
            Cancel
          </Button>
        </Flex>
      </Card>
    </ContentWrapper>
  )
}
